import { z } from 'zod'

export const UrlListSchema = z
	.array(z.string())
	.or(z.string().transform((value) => value.split('~')))
	.transform((v) => v.flatMap((s) => (s ? [s] : [])))
	.transform((v) => (v.length ? v : undefined))
	.optional()
